import { Link } from 'react-router';
import { getAdminCatalogCategoryDetailPath } from '../adminRoutes';
import { useCatalogChildCategories } from './useCatalogRelatedLists';
import { CatalogPagination } from './CatalogPagination';
import { CatalogRequestState } from './CatalogRequestState';

export function CatalogChildCategories({ categoryId }: { categoryId: number }) {
  const { query, page, setPage } = useCatalogChildCategories(categoryId);
  return (
    <section className="catalog-content-section" aria-labelledby="children-title">
      <header className="catalog-section-heading">
        <div>
          <h2 id="children-title">Подкатегории {query.data?.meta.total !== undefined ? <span>{query.data.meta.total}</span> : null}</h2>
          <p>Следующий уровень внутри этой категории.</p>
        </div>
      </header>
      {query.isPending || query.isError ? (
        <CatalogRequestState error={query.error?.message} onRetry={() => { void query.refetch(); }} />
      ) : query.data.items.length === 0 ? (
        <p className="catalog-empty-copy">Вложенных категорий нет.</p>
      ) : (
        <>
          <ul className="catalog-child-list">
            {query.data.items.map((category) => (
              <li key={category.category_id}>
                <Link to={getAdminCatalogCategoryDetailPath(category.category_id)}>{category.category_name}<span aria-hidden="true">→</span></Link>
              </li>
            ))}
          </ul>
          <CatalogPagination page={page} pageCount={query.data.meta.page_count ?? 1} onChange={setPage} />
        </>
      )}
    </section>
  );
}
